module.exports = __webpack_public_path__ + "static/media/ic_form_inactive.b9817e86.svg";